<app-card
  class="error-container"
  [width]="'478px'"
  [topPadding]="'1rem'" [sidePaddings]="'0'" [mobileSidePaddings]="'0'"
  [border]="'none'"
  [title]="title ? title : 'Ups... Coś poszło nie tak.' ">
  <div content>
    <p *ngIf="msg" class="text-center primary-color">
      {{ msg }}
    </p>
    <p *ngIf="(!!data.error?.errorHash) && !msg" class="text-center bold primary-color">
      Kod błędu: <code>{{ data.error.errorHash }}</code>
    </p>
  </div>
  <div buttons>
    <div matDialogActions align="end">
      <button *ngIf="handsetService.isMobile" mat-raised-button color="accent" (click)="onCall()">Zadzwoń</button>
      <button mat-button matDialogClose (click)="onReport()">Napisz</button>
    </div>
  </div>
</app-card>
